import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  computed,
  signal,
} from '@angular/core';
import { formatWithTimezone } from 'src/app/helpers/timezone/timezone.helpers';

@Component({
  selector: 'app-topbar-clock',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './topbar-clock.component.html',
  styleUrls: ['./topbar-clock.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopbarClockComponent implements OnInit, OnDestroy {
  private readonly now = signal(new Date());
  private intervalId?: ReturnType<typeof setInterval>;

  readonly timeLabel = computed(() => {
    return formatWithTimezone(this.now(), {
      hour: '2-digit',
      minute: '2-digit',
    });
  });

  readonly dateLabel = computed(() => {
    const weekDay = formatWithTimezone(this.now(), {
      weekday: 'short',
    }).replace('.', '');
    const dayMonth = formatWithTimezone(this.now(), {
      day: 'numeric',
      month: 'short',
    }).replace('.', '');

    return `${weekDay} ${dayMonth}`.trim();
  });

  ngOnInit(): void {
    this.syncClock();
    this.intervalId = setInterval(() => this.syncClock(), 1000);
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private syncClock(): void {
    this.now.set(new Date());
  }
}
